<template>
	<div class="option-box" :class="{ 'is-nowrap': nowrap }" :style="{ margin: `${-gap / 2}px` }">
		<div
			v-for="(option, index) in options"
			:key="option[valueKey] == null ? index : option[valueKey]"
			class="option-box__item"
			:class="{ 'is-selected': isSelected(option[valueKey]) }"
			:style="{ flexBasis: `calc(${100 / columns}% - ${gap}px)`, margin: `${gap / 2}px` }"
			@click="select(option[valueKey], option)"
		>
			<slot :option="option">{{ option[labelKey] }}</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OptionBox',
	props: {
		options: { type: Array, default: () => [] },
		value: { type: [String, Number, Array], default: '' },
		multiple: { type: Boolean, default: false },
		columns: { type: Number, default: 3 },
		gap: { type: Number, default: 10 },
		nowrap: { type: Boolean, default: false },
		labelKey: { type: String, default: 'label' },
		valueKey: { type: String, default: 'value' }
	},
	methods: {
		isSelected(value) {
			return this.multiple
				? Array.isArray(this.value) && this.value.indexOf(value) !== -1
				: this.value === value
		},
		select(value, valueItem) {
			const selected = Array.isArray(this.value) ? this.value : []
			const nextValue = this.multiple
				? this.isSelected(value)
					? selected.filter(item => item !== value)
					: selected.concat(value)
				: value

			this.$emit('input', nextValue)
			this.$emit('change', nextValue, valueItem)
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.option-box {
	display: flex;
	flex-wrap: wrap;

	&.is-nowrap {
		flex-wrap: nowrap;
		overflow-x: auto;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}
}

.option-box__item {
	@include body_2(1.5, 400, false);
	box-sizing: border-box;
	min-width: 24px;
	height: 35px;
	line-height: 35px;
	text-align: center;
	padding: 0 10px;
	border: 1px solid var(--border_divider_primary);
	color: $text_primary;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex-shrink: 0;
	&.is-selected {
		border-color: $text_primary;
	}
}
</style>
